import type { JSX } from 'react'
import type { IDropdownItemTypeButtonProps } from '../DropdownItemTypeButton'

import { DropdownItemProfileSC } from 'blocks/Dropdown/DropdownItems/DropdownItemTypeButton/DropdownItemTypeButton.styled'
import {
  DropdownItemBackgrounds,
  DropdownItemFontColors,
  DropdownItemFonts,
  DropdownItemPaddings,
} from '../../DropdownItem.h'
import { DropdownItemTypeButton } from '../DropdownItemTypeButton'

export const DropdownItemProfile = ({
  title = '',
  width = '224px',
  colorDefault = DropdownItemFontColors.TEXT_ICON_SECONDARY,
  colorHovered = DropdownItemFontColors.TEXT_ICON_CONSTANT_LIGHT,
  colorPressed = DropdownItemFontColors.TEXT_ICON_SECONDARY,
  colorSelected = DropdownItemFontColors.TEXT_ICON_PRIMARY,
  iconColorSelected = DropdownItemFontColors.ACCENT_TERTIARY,
  backgroundSelectedDefault = DropdownItemBackgrounds.SURFACE_OPACITY_LIGHT_10,
  paddings = DropdownItemPaddings.SIZE_10,
  children,
  font = DropdownItemFonts.Body4,
  selected,
  ...rest
}: IDropdownItemTypeButtonProps): JSX.Element => (
  <DropdownItemTypeButton
    title={title}
    selected={selected}
    colorDefault={colorDefault}
    colorHovered={colorHovered}
    colorPressed={colorPressed}
    colorSelected={colorSelected}
    iconColorSelected={iconColorSelected}
    backgroundSelectedDefault={backgroundSelectedDefault}
    paddings={paddings}
    width={width}
    // Redefine the default props Dropdown Item Type Button, because
    // calculations in em and leads to incorrect calculation of font sizes of child components
    font={null}
    {...rest}
  >
    <DropdownItemProfileSC font={font} selected={selected}>
      {children}
    </DropdownItemProfileSC>
  </DropdownItemTypeButton>
)
